import moment from 'moment';
import localeFunctions from './localeFunctions.js'

export default class DateFunctions {

    static calculateCampaignWeeks(startDate, endDate) {

        const startDt = moment(startDate);
        const endDt = moment(endDate);

        if (startDt.isoWeek() === endDt.isoWeek())
            return startDt.isoWeek()

        return startDt.isoWeek() + '-' + endDt.isoWeek();
    };

    static calculateWeek(date) {

        const dt = moment(date);

        return dt.isoWeek()
    };

    static daysBetweenDates(firstDateStr, secondDateStr) {

        const startDt = moment(firstDateStr);
        const endDt = moment(secondDateStr);
        var duration = moment.duration(startDt.diff(endDt));
        return Math.round(duration.asDays());
    };

    static getISOFormatFromDate(date) {
        return [date.getFullYear(), ('0' + (date.getMonth() + 1)).slice(-2), ('0' + date.getDate()).slice(-2)].join('-');
    }

    static parseDate(date) {

        // handle moment-datatype
        if (date && typeof date === 'object' && typeof date.toDate === 'function') {
            return date.toDate();
        }

        if (date instanceof Date) {
            return isNaN(date.getTime()) ? null : date;
        }

        if (typeof date === 'string' || typeof date === 'number') {
            const parsedDate = new Date(date);
            return isNaN(parsedDate.getTime()) ? null : parsedDate;
        }

        return null;
    } 

    // options is Intl.DateTimeFormat options
    static getCountrySpecificDateTimeFormatFromDate(countryCode, date, options) {

        try {
            if (!countryCode || typeof countryCode !== 'string') {
                throw new Error('Invalid country code');
            }

            // Convert input to Date object
            const dateObject = this.parseDate(date);
            if (!dateObject) {
                return null;
            }


            let formatOptions;
            formatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            };

            formatOptions = { ...formatOptions, ...options };

            const countryLocale = localeFunctions.getLocaleForCountry(countryCode);

            return new Intl.DateTimeFormat(countryLocale, formatOptions).format(dateObject);
        } catch (error) {
            console.error('Error formatting date:', error);
            return null;
        }
    }

    static getCountrySpecificDateFormatFromDate(countryCode, date, options) {
        try {
            if (!countryCode || typeof countryCode !== 'string') {
                throw new Error('Invalid country code');
            }

            // Convert input to Date object
            const dateObject = this.parseDate(date);
            if (!dateObject) {
                return null;
            }

            let formatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };

            // Allow overriding default format options
            formatOptions = { ...formatOptions, ...options };

            const countryLocale = localeFunctions.getLocaleForCountry(countryCode);

            return new Intl.DateTimeFormat(countryLocale, formatOptions).format(dateObject);
        } catch (error) {
            console.error('Error formatting date:', error);
            return null;
        }
    }


    static getCountrySpecificDateStringFormatFromCountry(countryCode) {
        try {
            if (!countryCode || typeof countryCode !== 'string') {
                throw new Error('Invalid country code');
            }

            const formatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };

            const countryLocale = localeFunctions.getLocaleForCountry(countryCode);

            const sampleDate = new Date(2000, 0, 1);
            const formatter = new Intl.DateTimeFormat(countryLocale, formatOptions);
            const parts = formatter.formatToParts(sampleDate);

            const formatString = parts.map(part => {
                switch (part.type) {
                    case 'year': return 'yyyy';
                    case 'month': return 'MM';
                    case 'day': return 'dd';
                    default: return part.value;
                }
            }).join('');

            return formatString;
        } catch (error) {
            console.error('Error deriving date string format:', error.message);
            return null;
        }
    }

    static calculateTotalCampaignWeeksNumber(startDate, endDate) {
        const startDt = moment(startDate);
        const endDt = moment(endDate);

        const totalWeeks = Math.ceil(endDt.diff(startDt, 'days') / 7);

        return totalWeeks;
    }

    static calculateWeeksPassed(startDate, endDate) {
        const startDt = moment(startDate);
        const currentDt = moment();
        const endDt = moment(endDate);

        const totalWeeks = this.calculateTotalCampaignWeeksNumber(startDate, endDate);

        if (currentDt.isBefore(startDt, 'day')) {
            return 0;
        }

        let weeksPassed = Math.ceil((currentDt.diff(startDt, 'days') + 1) / 7);

        return Math.min(weeksPassed, totalWeeks);
    }
}